import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import Rosetta from './Rosetta';
import Dashboard from './Dashboard';
import Companies from './Companies';
import Coupon from './Coupon/Coupon';
import Operations from './Operations';
import ScopeConsole from './ScopeConsole';
import { SOPManagement } from './SOP';
import CopyTransfer from './CopyTransfer';
import ValidateRequests from './ValidateRequests';
import Promotional from './Promotional/Promotional';
import EnterpriseDashboard from './EnterpriseDashboard';

const MainPage = () => {
  const location = useLocation();

  const ROUTES = [
    { path: '/', component: Dashboard },
    { path: '/company', component: Companies },
    { path: '/enterprise-dashboard', component: EnterpriseDashboard },
    { path: '/copy-transfer', component: CopyTransfer },
    { path: '/operations', component: Operations },
    { path: '/validate-requests', component: ValidateRequests },
    { path: '/coupon', component: Coupon },
    { path: '/promotional', component: Promotional },
    { path: '/sop-management', component: SOPManagement },
    { path: '/rosetta', component: Rosetta },
    { path: '/scope-console', component: ScopeConsole },
  ];

  if (!ROUTES.map(route => route.path).includes(location.pathname)) {
    window.location.href = '/';
  }

  return (
    <Routes>
      {ROUTES.map((route, key) => {
        return <Route key={key} path={route.path} element={<route.component />} />;
      })}
    </Routes>
  );
};

export default MainPage;
